<template>
  <div class="popup_wrap">
    <span class="ticket_btnbox">
      <span class="checkbox">
        <input type="checkbox" :id="'agree-checkbox' + id" v-model="inputVal" />
        <label :for="'agree-checkbox' + id">개인정보 수집·이용 동의</label>
      </span>
      <a class="openPopup" @click="openModal">전문보기</a>
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="개인정보 수집·이용 동의 안내">
      <!-- default 슬롯 콘텐츠 -->
      <div>
        <p class="colorbox mb20">
          한국잡월드는 체험관예약/결재 관리업무와 관련하여 아래와 같이 개인정보를 수집‧이용하고자 합니다.
          <br />
          내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오.
        </p>
        <h5 class="stitle2 mb10">개인정보 수집‧이용 내역</h5>
        <div class="tb_wrap mb10">
          <table class="tb_basic">
            <caption>개인정보 수집‧이용 내역</caption>
            <colgroup>
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr class="tbg">
                <th scope="col">수집‧이용 항목</th>
                <th scope="col">수집‧이용 목적</th>
                <th scope="col">보유기간</th>
              </tr>
            </thead>
            <tbody class="strong">
              <tr>
                <td>
                  <p class="tcolor1">필수항목</p>
                  <dl class="mb10">
                    <dt>예약자정보</dt>
                    <dd>
                      예약자 이름
                      <br />
                      예약자 연락처
                      <br />
                      예약자 휴대폰
                      <br />
                      예약자 E-mail
                    </dd>
                    <dt>결제정보</dt>
                    <dd>
                      결제/환불자 이름
                      <br />
                      결제방법
                      <br />
                      결제/환불자 은행
                      <br />
                      결제/환불자 계좌정보
                    </dd>
                    <dt>체험자정보</dt>
                    <dd>
                      체험자 이름
                      <br />
                      체험자 학년
                      <br />
                      체험자 생년월일
                      <br />
                      체험자 E-mail
                    </dd>
                    <dt>인솔자정보</dt>
                    <dd>
                      인솔자 이름
                      <br />
                      인솔자 휴대폰
                      <br />
                      인솔자 E-mail
                    </dd>
                  </dl>
                  <p class="tcolor1">선택항목</p>
                  <dl>
                    <dt>체험자 회원 아이디</dt>
                    <dd>
                      체험자 반
                      <br />
                      체험자 번호
                    </dd>
                  </dl>
                </td>
                <td>
                  청소년 및 어린이체험관
                  <br />
                  숙련기술체험관
                  <br />
                  미래직업관
                  <br />
                  개인/단체 예약관리
                </td>
                <td>회원탈퇴 시</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mb20">
          ※ 위의 개인정보 수집‧이용에 대한 동의를 거부할 권리가 있습니다.
          <br />
          그러나 동의를 거부할 경우 원활한 체험관예약 관리업무를 할 수 없어 한국잡월드 체험서비스에 제한을 받을 수 있습니다.
        </p>
      </div>
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <div class="btn_wrap tcen">
          <a class="wdhalf btn btn_bg gray" @click="() => onButtonClick(false)">비동의</a>
          <a class="wdhalf btn btn_bg color" @click="() => onButtonClick(true)">동의</a>
        </div>
        <!-- <button @click="selectPcnt">확인</button>
        <button @click="closeModal">취소</button> -->
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
export default {
  components: { Modal },
  props: ['value', 'id'],
  data() {
    return {
      modal: {
        open: false,
      },
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {},
  methods: {
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    onButtonClick(agree) {
      this.$emit('input', agree);
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
  & .checkbox input[type='checkbox'] + label {
    font-size: 16px;
    display: inline-block;
    height: 19px;
    padding-left: 23px;
    line-height: 19px;
    background-size: 19px 19px;
    width: initial;
  }
  & .strong {
    font-weight: bold;
  }
}
</style>
